<template>
    <div class="modal-background">
        <div v-show="!isResultView">
            <div class="modal-card pt-6">
                <header class="modal-card-head">
                    <p class="modal-card-title">Set RingCentral GroupChat LastMessageDates</p>
                    <button class="delete is-medium" @click="close()" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    <div class="content">
                        <p> Sets RingCentral.ExternalGroupChat.LastMessageDate and will delete the oldest group chats accordingly. </p>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button :class="isLoading ? 'button is-primary is-loading' : 'button is-primary'"
                            @click="queueSetRingCentralGroupChatLastMessageDates()">
                        Queue Set RingCentral GroupChat LastMessageDates
                    </button>
                    <button class="button is-primary" @click="close()">Cancel</button>
                </footer>
            </div>
        </div>
        <div v-show="isResultView">
            <div class="modal-card pt-6">
                <header class="modal-card-head">
                    <p class="modal-card-title">Result</p>
                    <button class="delete is-medium" @click="close()" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    <div class="message is-success">
                        <div class="message-header">
                            <p>Success</p>
                        </div>
                        <div class="message-body">
                            <p>Set RingCentral GroupChat LastMessageDates job has been queued.</p>
                            <p>Job Id: {{ jobId }}</p>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button is-primary" @click="close()">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import { securePost } from '../../secureFetch.js';

export default {
    name: "SetRingCentralGroupChatLastMessageDatesModal",
    computed: {
        hostUrl: function () {
            return this.$store.state.hostUrl;
        },
    },
    data() {
        return {
            isLoading: false,
            isResultView: false,
            errorMessage: null,
            jobId: null,
        };
    },
    methods: {
        close() {
            this.isLoading = false;
            this.isResultView = false;
            this.errorMessage = null;
            this.jobId = null;
            this.$emit("close");
        },
        closeResults() {
            this.isResultView = false;
            this.errorMessage = null;
            this.jobId = null;
        },
        async queueSetRingCentralGroupChatLastMessageDates() {
            this.isLoading = true;

            const result = await securePost(this.hostUrl + "v1/utilityjob/queue-set-ring-central-group-chat-last-message-dates");

            this.isLoading = false;

            if (result != null && result.success) {
                this.jobId = result.jobId;
                this.isResultView = true;
            }
            else {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: `${result.message ? "Error: " + result.message : "Something went wrong."}`,
                    position: 'is-bottom',
                    type: 'is-danger',
                })
            }
        },
    },
};
</script>

<style scoped>
    .modal-card {
        overflow: visible;
        max-width: 820px;
        width: fit-content;
    }

    .modal-card-body {
        overflow: visible;
        max-width: 780px;
        width: fit-content;
    }

    .list {
        padding: 0;
        margin-top: 0;
        margin-bottom: 0;
    }

    .list-item {
        margin: 0;
    }
</style>